import { Component } from '@angular/core';
import {
  MatDialogClose,
  MatDialogContent,
  MatDialogTitle,
} from '@angular/material/dialog';
import { TranslatePipe } from '@ngx-translate/core';

import {
  OpeningDay,
  TimePoint,
  TimeRange,
  Weekday,
  weekDays,
} from '../../../../../lead.model';
import { MatButton, MatIconButton } from '@angular/material/button';
import { MatIcon } from '@angular/material/icon';
import { CurrentOpeningTimesService } from '../current-opening-times.service';
import { timeRangeIsWholeDay } from '../opening-times.utils';

@Component({
  selector: 'app-opening-times-overview',
  imports: [
    MatDialogContent,
    MatDialogTitle,
    TranslatePipe,
    MatIconButton,
    MatIcon,
    MatButton,
    MatDialogClose,
  ],
  templateUrl: './opening-times-overview.component.html',
  styleUrl: './opening-times-overview.component.scss',
})
export class OpeningTimesOverviewComponent {
  constructor(
    protected currentOpeningTimesService: CurrentOpeningTimesService,
  ) {}

  editOpeningTimes(weekDay: Weekday) {
    const currentDay =
      this.currentOpeningTimesService.getCurrentOpeningDay(weekDay);
    if (currentDay === undefined || currentDay.timeRange.length === 0) {
      this.currentOpeningTimesService.setCurrentComponent({
        type: 'specificOpeningTimes',
        selectedDays: [weekDay],
        wholeDayOpened: false,
        wholeDayClosed: true,
        timeRanges: [],
      });
    } else if (timeRangeIsWholeDay(currentDay.timeRange)) {
      this.currentOpeningTimesService.setCurrentComponent({
        type: 'specificOpeningTimes',
        selectedDays: [weekDay],
        wholeDayOpened: true,
        wholeDayClosed: false,
        timeRanges: [],
      });
    } else {
      this.currentOpeningTimesService.setCurrentComponent({
        type: 'specificOpeningTimes',
        selectedDays: [weekDay],
        wholeDayOpened: false,
        wholeDayClosed: false,
        timeRanges: currentDay.timeRange,
      });
    }
  }

  editAllOpeningTimes() {
    this.currentOpeningTimesService.setCurrentComponent({
      type: 'specificOpeningTimes',
      selectedDays: ['MONDAY', 'TUESDAY', 'WEDNESDAY', 'THURSDAY', 'FRIDAY'],
      wholeDayOpened: false,
      wholeDayClosed: false,
      timeRanges: [
        {
          start: { hour: 8, minute: 0 },
          end: { hour: 16, minute: 30 },
        },
      ],
    });
  }

  getCrossedOpeningTimes(weekDay: Weekday): string | undefined {
    const initialOpeningTime: OpeningDay | undefined =
      this.currentOpeningTimesService.getInitialOpeningDay(weekDay);
    let initialOpeningTimeText = 'components.opening-times-overview.closed';
    if (initialOpeningTime && initialOpeningTime.timeRange.length > 0) {
      initialOpeningTimeText = this.timeRangesToString(
        initialOpeningTime.timeRange,
      );
    }
    if (this.getOpeningTimes(weekDay) !== initialOpeningTimeText) {
      return initialOpeningTimeText;
    } else {
      return undefined;
    }
  }

  getOpeningTimes(weekDay: Weekday) {
    const openingTime =
      this.currentOpeningTimesService.getCurrentOpeningDay(weekDay);
    if (openingTime && openingTime.timeRange.length > 0) {
      return this.timeRangesToString(openingTime.timeRange);
    } else {
      return 'components.opening-times-overview.closed';
    }
  }

  timeRangesToString(timeRanges: TimeRange[]): string {
    const timeToString = (time: TimePoint) =>
      `${time.hour.toString().padStart(2, '0')}:${time.minute.toString().padStart(2, '0')}`;
    return timeRanges
      .map(
        (timeRange: TimeRange) =>
          timeToString(timeRange.start) + ' - ' + timeToString(timeRange.end),
      )
      .join('\n');
  }

  protected readonly weekDays = weekDays;
}
